import {DashboardComponentGroupReportOptions} from "./DashboardReportOptions";
import {DashboardComponent} from "./DashboardComponent";

export namespace DashboardComponentGroup {
    export interface Layout {
        type: LayoutType;
        gap: number;
        justify: Justify;
        align: Align;
    }

    export enum LayoutType {
        VERTICAL = 'VERTICAL',
        HORIZONTAL_FLEX = 'HORIZONTAL_FLEX',
    }

    export enum Justify {
        START = 'START',
        END = 'END',
        CENTER = 'CENTER',
        BETWEEN = 'BETWEEN',
        AROUND = 'AROUND',
        EVENLY = 'EVENLY',
    }

    export enum Align {
        STRETCH = 'STRETCH',
        START = 'START',
        END = 'END',
        CENTER = 'CENTER',
    }
}

export interface DashboardComponentGroup {
    components: Array<DashboardComponent>;
    layout: DashboardComponentGroup.Layout;
    reportOptions?: DashboardComponentGroupReportOptions;
}